import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import MainLinks from './MainLinks';
import NavBar from './NavBar';
import ArtistDetail from './ArtistDetail';
import WhoWeAre from './WhoWeAre';
import ContactUs from './ContactUs';


function App() {
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [bgPosition, setBgPosition] = useState('center');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);

  return (
    <Router>
      <div className="App">

        <NavBar onMenuClick={() => setIsMenuOpen(true)} />

        <Routes>
          <Route
            path="/"
            element={
              <div className="main-content home">
                {/* Background video — fixed and behind everything */}
                <video
                  className={`video-background ${videoLoaded ? 'loaded' : 'loading'}`}
                  src="/videos/bg-vid-bw-compressed.mov"
                  poster="/videos/bg-vid-bw-poster.jpg"
                  autoPlay
                  muted
                  loop
                  playsInline
                  controls={false}
                  controlsList="nodownload nofullscreen noremoteplayback"
                  disablePictureInPicture
                  preload="metadata"
                  onCanPlay={() => setVideoLoaded(true)}
                  onPlaying={() => setVideoLoaded(true)}
                  onTimeUpdate={() => setVideoLoaded(true)}
                />

                {/* Background image overlay (hover) */}
                <div
                  className={`bg-overlay ${backgroundImage ? 'visible' : ''}`}
                  style={{
                    backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
                    backgroundSize: 'cover',
                    backgroundPosition: bgPosition,
                    backgroundRepeat: 'no-repeat',
                  }}
                />

                {/* Foreground links */}
                <div className="overlay-content">
                  <MainLinks setBackgroundImage={setBackgroundImage} setBgPosition={setBgPosition} />
                </div>
              </div>
            }
          />

          <Route path="/artist/:slug" element={<ArtistDetail />} />
          <Route path="/who-we-are" element={<WhoWeAre />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>

        {/* Modal menu */}
        {isMenuOpen && (
          <div className="fullscreen-modal">
            <button className="close-button" onClick={() => setIsMenuOpen(false)}>
              ×
            </button>
            <div className="modal-content">
              <Link to="/" className="modal-link black-strike" onClick={() => setIsMenuOpen(false)}>ARTISTS</Link>
              <a href="https://ra.co/promoters/132855" target="_blank" rel="noopener noreferrer" className="modal-link black-strike" onClick={() => setIsMenuOpen(false)}>EVENTS</a>
              <Link to="/who-we-are" className="modal-link black-strike" onClick={() => setIsMenuOpen(false)}>WHO WE ARE</Link>
              <Link to="/contact" className="modal-link black-strike" onClick={() => setIsMenuOpen(false)}>CONTACT</Link>
            </div>
          </div>
        )}
      </div>
    </Router>
  );
}

export default App;